import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { selectProjectAccount, useGetAccountModulesQuery } from "fond/api";
import { Architecture as _Architecture, ArchitectureBase, MultiProject, Project, Store } from "fond/types";
import { isExtendedPlannerProject } from "fond/utils/project";
import { SharedInputGlobalStyles } from "fond/widgets";

import ArchitectureContent from "./ArchitectureContent";
import { ArchitectureTabId } from "./architectureTabHeaders";
import { ArchitectureEditorContextProvider, load, useArchitectureEditorContext } from "./context";

interface IProps {
  project: Project | MultiProject;
  architecture: _Architecture | ArchitectureBase | null;
  /**
   * The tab to open on, if the architecture is configured.
   */
  initialTabId?: ArchitectureTabId;
  onClose(): void;
}

const Architecture: React.FC<IProps> = ({ project, architecture, initialTabId, onClose }: IProps) => {
  return (
    <SharedInputGlobalStyles>
      <ArchitectureEditorContextProvider>
        <ArchitectureWrapper project={project} architecture={architecture} initialTabId={initialTabId} onClose={onClose} />
      </ArchitectureEditorContextProvider>
    </SharedInputGlobalStyles>
  );
};

const ArchitectureWrapper: React.FC<IProps> = ({ project, architecture, initialTabId, onClose }: IProps) => {
  const [, dispatch] = useArchitectureEditorContext();
  const bomArchRestrictions = useSelector((state: Store) => selectProjectAccount(state, project)?.BomArchRestrictions);
  const { data: accountModules } = useGetAccountModulesQuery(project.Account.ID);

  useEffect(() => {
    dispatch(
      load(project.Account, accountModules, architecture, bomArchRestrictions, project.SystemOfMeasurement, {
        showDesignPreferences: isExtendedPlannerProject(project),
        initialTabId,
      })
    );
  }, []);

  return <ArchitectureContent project={project} onClose={onClose} />;
};

export default Architecture;
